import Promise from 'bluebird';
import { API_ROOT } from 'configs/env-vars';
import { emptyState } from 'configs/localStorage';
import { createHttpClient } from './httpClient';

Promise.config({
  cancellation: true,
});

// overwrite native Promise implementation with Bluebird's
window.Promise = Promise;

const ClientServices = (
  headers = {
    Pragma: 'no-cache',
    'Cache-Control': 'no-cache, no-store',
    ...(process.env.NODE_ENV === 'production' ? { 'csrf-token': document.getElementById('csrf-token').content } : {}),
  },
) => {
  const service = createHttpClient({
    baseURL: API_ROOT, // url of the api
    headers,
    withCredentials: true,
  });
  service.interceptors.response.use(response => response);
  service.interceptors.response.use(responseOrError => {
    if (!responseOrError || !responseOrError.response) {
      return responseOrError;
    }

    const errorResponse = responseOrError.response;
    const requestUrl = responseOrError.config?.url || '';

    // List of endpoints that should not trigger automatic redirects on 404
    // personify-connection: status/unlink must not bounce the whole app to /not-found
    const ignoredEndpoints = ['/conversations', '/personify-connection'];
    const shouldIgnore404 = ignoredEndpoints.some(endpoint => requestUrl.includes(endpoint));

    switch (errorResponse.status) {
      case 404:
        // Only redirect to not-found if it's not an ignored endpoint
        if (!shouldIgnore404) {
          window.location.pathname = '/not-found';
        }
        break;
      case 403:
        window.location.pathname = '/not-permitted';
        break;
      default:
        break;
    }
    if (errorResponse?.status === 401) {
      emptyState();
      window.location.reload();
    }
    return responseOrError;
  });
  return service;
};

export default ClientServices;
